import Alpine from 'alpinejs';
import { initBlogVideos } from './blog-video.js';
import { initBlockReveals } from './block-reveal.js';
import { initBackgroundWash } from './background-wash.js';
import { initBackgroundWashReveals } from './background-wash-reveal.js';
import { initDentrWidget } from './dentr-widget.js';
import { initEntryCarousels } from './entry-carousel.js';
import { initHeroDecor } from './hero-decor.js';
import { initHomeHero } from './home-hero.js';
import { initImageFeatures } from './image-feature.js';
import { initIntroBlocks } from './intro-block.js';
import { initNoticeBars } from './notice-bar.js';
import { initSharedGradientCards } from './shared-gradient-cards.js';
import { initTwoColumnSticky } from './two-column-sticky.js';

// Components

// Global
window.Alpine = Alpine;

// Inits
initBlogVideos();
initBlockReveals();
initBackgroundWash();
initBackgroundWashReveals();
initDentrWidget();
initHeroDecor();
initHomeHero();
initImageFeatures();
initIntroBlocks();
initNoticeBars();
initSharedGradientCards();
initEntryCarousels();
initTwoColumnSticky();
Alpine.start();
